import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { ModelEntityType } from '../../../../../../../common/model/input/types';
import { ImpactExplanationModal } from '../impact-explanation-modal';
import { useImpactChartContext } from './context';

export function ImpactExplanationModalMaybe() {
  const { modalImpactCode, setModalImpactCode, data } = useImpactChartContext();
  return (
    <ImpactExplanationModal
      isOpen={!!modalImpactCode}
      impactCode={modalImpactCode || ImpactCategoryId.GHG_EMISSIONS}
      type={data.length === 1 ? data[0].type : ModelEntityType.COMPANY}
      onClose={() => {
        setModalImpactCode(undefined);
      }}
    />
  );
}
